import './component.css';
import { useTranslation } from 'react-i18next';
import { Grid, Typography } from '@mui/material';
import React from 'react';

const SchoolDemographic = ({ patient }) => {
    const { t } = useTranslation();
    const { school } = patient;

    const renderAddress = (address) => {
        let text = '';

        if (address) {
            text = address.postalCode ? `${address.postalCode}\n` : '-';
            const addressLines = address.addressLines || address.lines;
            if (addressLines && addressLines.length > 0) {
                addressLines.forEach((element) => {
                    text += element ? `${element}\n` : '';
                });
            }
        }

        return (
            <Grid item xs={3} className="container-grid">
                <Typography variant="body1" className="title">
                    {`${t('Address')}`}
                </Typography>

                {address?.type && (
                    <Typography variant="body1" className="body">
                        {t('Type')}: {address.typeName || '-'}
                    </Typography>
                )}

                <Typography variant="body1" className="body" style={{ whiteSpace: 'pre-wrap' }}>
                    {text || '-'}
                </Typography>
            </Grid>
        );
    };

    return (
        <Grid container spacing={1} columns={9} className="container" alignContent="flex-start">
            <Grid item xs={3} className="container-grid">
                <Typography variant="body1" className="title">
                    {t('School Name')}
                </Typography>

                <Typography variant="body1" className="body">
                    {school?.name || '-'}
                </Typography>
            </Grid>

            <Grid item xs={3} className="container-grid">
                <Typography variant="body1" className="title">
                    {t('School Telephone')}
                </Typography>

                <Typography variant="body1" className="body">
                    {school?.contact || '-'}
                </Typography>
            </Grid>

            {renderAddress(school?.address)}
        </Grid>
    );
};

export default React.memo(SchoolDemographic);
